// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5952867c","952":"c5cbadde"}[chunkId] + ".chunk.js";
};